import React, { createContext, useContext, useState, useEffect } from 'react';
import { useUser } from './UserContext';
import {useModal} from "./ModalContext";

const AlertContext = createContext();

export const useAlert = () => useContext(AlertContext);

export const AlertProvider = ({ children }) => {
    const [isAlertVisible, setAlertVisible] = useState(false);
    const { user } = useUser();
    const { showModal, hideModal } = useModal();

    useEffect(() => {
        if (user && user.alert) {
            console.warn('Alerte: ', user.alert);

            setTimeout(() => {
                showModal('alert', {data: user.alert, onClose: () => hideModal()});
            }, process.env.REACT_APP_SHOW_ALERT_DELAY);

            setAlertVisible(true);
        } else {
            setAlertVisible(false);
        }
    }, [user]);

    return (
        <AlertContext.Provider value={{ isAlertVisible, setAlertVisible }}>
            {children}
        </AlertContext.Provider>
    );
};